/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { format as formatDateFns, isAfter, isValid, parseISO, startOfDay, subDays } from 'date-fns';

import {
  getTrailerRequestByUserIDEffect,
  getTrailerRequestsEffect,
  getUserRelationEffect,
} from '../../../redux/Savers/SaversEffects';
import '../../../styles/savers/custom.css';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, DatePicker, Form, message, Row } from 'antd';
import { uniqBy } from 'es-toolkit';
import { ArrowRightOutlined } from '@ant-design/icons';

import { setTrailerRequestId } from '@/redux/Savers/SaversActions';
import { getLocalDateTime } from '@/utils/date';
import { exportSaversDataToExcel } from '@/utils/excel';
import TrailerScsSelector from '@/views/components/Selectors/TrailerScsSelector';
import TrailerStatusSelector from '@/views/components/Selectors/TrailerStatusSelector';
import TrailerStoreIdSelector from '@/views/components/Selectors/TrailerStoreIdSelector';

import SecondaryLabel from '../../components/Labels/SecondaryLabel';
import ContentSpinner from '../../components/Spinners/ContentSpinner';
import SaversHomeGrid from './SaversHomeGrid';

const columnFormatter = () => {
  return (
    <span>
      {' '}
      <Link className="color-1" to="">
        <ArrowRightOutlined />
      </Link>{' '}
    </span>
  );
};

export default function Home() {
  const [formHome] = Form.useForm();
  const { RangePicker } = DatePicker;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const userType = useSelector((state) => state.savers.loggedInUser.data);

  const [selectedRange, setSelectedRange] = useState([]);
  const [trailerRequests, setTrailerRequests] = useState([]);
  const [filters, setFilters] = useState({
    assignedToFilterValue: '',
    cscFilterValue: '',
    filterValue: '',
    rscmFilterValue: '',
    storeIdFilterValue: '',
  });
  const [trailerRequestCt, setTrailerRequestCt] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errMessage, setErrMessage] = useState('');
  const [relationId, setRelationId] = useState('');
  const [pageIndex, setPageIndex] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [vendorId, setVendorId] = useState('');
  const { rscmFilterValue, cscFilterValue, assignedToFilterValue, storeIdFilterValue } = filters;
  const mergeUniqueRequests = (existingData, newData) => {
    return uniqBy([...existingData, ...newData], (item) => item.trailerRequestID);
  };

  const getTrailerRequestsByUser = async ({ userIDValue, pageNo }) => {
    try {
      const { data } = await getTrailerRequestByUserIDEffect(userIDValue, pageNo);

      setCurrentPage(data.totalRequestCount);
      if (data.trailerRequestData.length === 0) {
        setErrMessage('Data not found');
      } else {
        setErrMessage('');
        setTrailerRequests((prev) => mergeUniqueRequests(prev, data.trailerRequestData));
      }
    } catch (error) {
      console.error(error);
      setTrailerRequests([]);
    }
  };

  const getTrailerRequests = async () => {
    try {
      const { data } = await getTrailerRequestsEffect({ pageNo: 1 });
      setCurrentPage(data.totalRequestCount);
      if (data.trailerRequestData.length === 0) {
        setErrMessage('Data not found');
      } else {
        setErrMessage('');
        setTrailerRequests((prev) => mergeUniqueRequests(prev, data.trailerRequestData));
      }
    } catch (error) {
      console.error(error);
      setTrailerRequests([]);
    }
  };

  const loadTrailerRequestData = (requestID) => {
    dispatch(setTrailerRequestId(requestID));
    navigate('/Trailer-Review');
  };

  const getUserRelations = async () => {
    try {
      const { data } = await getUserRelationEffect();

      if (data.length > 0) {
        const user = data[0];
        setRelationId(user.userID);
        setVendorId(user.branchCustRef);
        if (user.userType === 'Store' || user.userType === 'Supplier') {
          formHome.setFieldsValue({
            RSCM: user.rscm,
            SCS: user.scs,
            Supplier: user.branchDesc,
          });
          await getTrailerRequestsByUser({ pageNo: 1, userIDValue: user.userID });
        } else if (user.userType === 'CT') {
          getTrailerRequests();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleNextPage = async () => {
    if (loadingNextPage || currentPage === trailerRequestCt.length) {
      return;
    }

    try {
      setLoadingNextPage(true);
      const nextPageNo = pageIndex + 1;
      setPageIndex(pageIndex + 1);
      if (userType === 'CT') {
        const { data } = await getTrailerRequestsEffect({
          pageNo: nextPageNo,
          trailerRequestStatusIDs: filters.filterValue || [],
        });
        const filteredTrailerRequests = filterData(data.trailerRequestData);
        setTrailerRequestCt((prev) => [...prev, ...filteredTrailerRequests]);
      } else if (userType === 'Store  ' || userType === 'Supplier') {
        const { data } = await getTrailerRequestsByUser({
          pageNo: nextPageNo,
          userIDValue: relationId,
        });
        const filteredTrailerRequests = filterData(data);
        setTrailerRequestCt((prev) => [
          ...prev,
          ...filteredTrailerRequests.filter((row) => {
            const createdParsed = parseISO(row.createdOn);
            const createdAtStartOfDay = isValid(createdParsed) ? startOfDay(createdParsed) : null;
            const sevenDaysAgo = startOfDay(subDays(getLocalDateTime(), 7));
            if (!createdAtStartOfDay) {
              return false;
            }
            return isAfter(createdAtStartOfDay, sevenDaysAgo);
          }),
        ]);
      }
    } catch (error) {
      console.error('Error loading next page:', error);
    } finally {
      setLoadingNextPage(false);
    }
  };

  const columns = [
    {
      dataField: 'trailerRequestID',
      hidden: true,
      text: 'id',
    },
    {
      dataField: 'branchCustRef',
      headerStyle: { textAlign: 'center' },
      sort: true,
      text: 'Location ID',
    },
    {
      dataField: 'isSpecialInstruction',
      formatter: (_, row) => {
        if (row.isSpecialInstruction) {
          return <span style={{ color: 'red', fontWeight: 'bold' }}>Yes</span>;
        }
        return <span>No</span>;
      },
      headerStyle: { textAlign: 'center' },
      sort: true,
      text: 'Special Instruction',
    },
    {
      align: 'left',
      dataField: 'fullName',
      headerStyle: { textAlign: 'center' },
      sort: true,
      text: 'Assigned To',
    },
    {
      align: 'left',
      dataField: 'rscm',
      headerStyle: { textAlign: 'center', width: '150px' },
      text: 'RSCM',
    },
    {
      align: 'left',
      dataField: 'productTypeDesc',
      formatter: (_, row) => {
        if (row.isEmptyPickUp) {
          return 'Empty';
        }
        if (row.isLoadedPickUp) {
          return row.productTypeDesc;
        }
        return 'NA';
      },
      headerStyle: { textAlign: 'center', width: '150px' },
      text: 'Pickup',
    },
    {
      align: 'left',
      dataField: 'deliveryProductTypeDesc',
      formatter: (_, row) => {
        if (row.isEmptyDelivered) {
          return 'Empty';
        }
        if (row.isLoadedDelivered) {
          return row.deliveryProductTypeDesc;
        }
        return 'NA';
      },
      headerStyle: { textAlign: 'center', width: '150px' },
      text: 'Deliver',
    },
    {
      align: 'left',
      dataField: 'deliveryDate',
      formatter: (_, row) => {
        if (row.trailerRequestDate) {
          const parsed = parseISO(row.trailerRequestDate);
          const date = `${formatDateFns(parsed, 'MM/dd/yy')}`;
          return date;
        }
        if (row.deliveryDate) {
          const parsed = parseISO(row.deliveryDate);
          const date = `${formatDateFns(parsed, 'MM/dd/yy')}`;
          return date;
        }
      },
      headerStyle: { textAlign: 'center', width: '200px' },
      sort: true,
      text: 'Pickup/Delivery Date',
    },
    {
      align: 'left',
      dataField: 'deliveryTimeFrame',
      formatter: (_, row) => {
        if (!row.deliveryTimeFrame) {
          return 'NA';
        }
        const date = `${row.deliveryTimeFrame}`;
        return date;
      },
      headerStyle: { textAlign: 'center', width: '200px' },
      sort: true,
      text: 'Delivery Time',
    },
    {
      align: 'left',
      dataField: 'trailerRequestStatusDesc',
      headerStyle: { textAlign: 'center' },
      sort: true,
      text: 'Status',
    },
    {
      align: 'left',
      dataField: 'comments',
      headerStyle: { textAlign: 'center' },
      text: 'Comments',
    },
    {
      align: 'center',
      dataField: 'trailerRequestID',
      events: {
        onClick: (_e, _column, _columnIndex, row, _rowIndex) => {
          loadTrailerRequestData(row.trailerRequestID);
        },
      },
      formatter: (_cell, row) => {
        if (userType === 'CT') {
          return columnFormatter();
        }

        if (
          (userType === 'Supplier' || userType === 'Store') &&
          String(row.trailerRequestStatusDesc).toLowerCase() === 'submitted'
        ) {
          return columnFormatter();
        }

        return null;
      },
      headerStyle: { textAlign: 'center' },
      text: 'Go to Request',
    },
  ];

  const compareDate = (dateToCompare) => {
    if (selectedRange.length !== 2) {
      message.warning('Please select a date range first!');
      return;
    }

    const startDate = selectedRange[0];
    const endDate = selectedRange[1];

    if (startDate && endDate) {
      const isWithinRange = dateToCompare >= startDate && dateToCompare <= endDate;

      return isWithinRange;
    }
  };

  const filterData = (data) => {
    if (
      !rscmFilterValue &&
      !cscFilterValue &&
      !assignedToFilterValue &&
      !storeIdFilterValue &&
      selectedRange.length === 0
    ) {
      return data;
    }

    return data.filter((row) => {
      const createdParsed = parseISO(row.createdOn);
      const createdDateStr = isValid(createdParsed) ? formatDateFns(createdParsed, 'yyyy-MM-dd') : '';

      const filters = [
        !rscmFilterValue || String(row.rscm).toLowerCase() === String(rscmFilterValue).toLowerCase(),
        !cscFilterValue || String(row.scs).toLowerCase() === String(cscFilterValue).toLowerCase(),
        !assignedToFilterValue || String(row.fullName).toLowerCase() === String(assignedToFilterValue).toLowerCase(),
        selectedRange.length === 0 || (createdDateStr !== '' && compareDate(createdDateStr)),
        !storeIdFilterValue || String(row.locationID).toLowerCase() === String(storeIdFilterValue).toLowerCase(),
      ];

      return filters.every(Boolean);
    });
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: fix this
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getUserRelations();
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [companyId]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: fix this
  useEffect(() => {
    const filteredTrailerRequests = filterData(trailerRequests);
    if (userType.toLowerCase() !== 'ct' && selectedRange.length === 0) {
      setTrailerRequestCt(
        filteredTrailerRequests.filter((row) => {
          const createdParsed = parseISO(row.createdOn);
          const createdAtStartOfDay = isValid(createdParsed) ? startOfDay(createdParsed) : null;
          const sevenDaysAgo = startOfDay(subDays(getLocalDateTime(), 7));
          if (!createdAtStartOfDay) {
            return false;
          }
          return isAfter(createdAtStartOfDay, sevenDaysAgo);
        }),
      );
    } else {
      setTrailerRequestCt(filteredTrailerRequests);
    }
  }, [selectedRange, userType, trailerRequests, filters]);

  const handleExport = () => {
    const filteredColumns = columns.filter((column) => !column.hidden && column.dataField !== 'trailerRequestID');
    exportSaversDataToExcel(trailerRequestCt, 'Trailer_Request_Data', filteredColumns);
  };

  const handleChange = (_dates, dateStrings) => {
    const cleanData = dateStrings.filter((item) => item?.trim());
    if (cleanData.length > 0) {
      setSelectedRange(cleanData);
    } else {
      setSelectedRange([]);
    }
  };
  const handleFilterChange = async (value, key) => {
    if (!value || value.length === 0) {
      setFilters((prev) => ({ ...prev, [key]: '' }));
      return;
    }
    const valueMap = {
      default: value?.label || '',
      filterValue: Array.isArray(value) ? value.join(',') : '',
      storeIdFilterValue: value?.value || '',
    };

    const values = valueMap[key] ?? valueMap.default;

    setFilters((prev) => ({ ...prev, [key]: values }));

    if (key !== 'filterValue') {
      return;
    }

    try {
      setLoading(true);
      if (userType === 'CT') {
        const { data } = await getTrailerRequestsEffect({
          pageNo: 1,
          trailerRequestStatusIDs: values,
        });
        const filteredTrailerRequests = filterData(data.trailerRequestData);
        setTrailerRequestCt(filteredTrailerRequests);
      }
    } catch (error) {
      console.error('Error fetching trailer requests:', error);
      setErrMessage('Something went wrong. Please try again.');
    } finally {
      setPageIndex(1);
      setLoading(false);
    }
  };

  return (
    <>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1" style={{ marginTop: '-26px', position: 'fixed', right: '32px' }}>
            <strong> {userType} </strong> Logged In{' '}
          </span>
        </Col>
      </Row>
      <div className="paper-container h-100 w-100">
        <Form form={formHome}>
          <div className="py-5 px-10">
            {userType !== 'Supplier' && (
              <Row gutter={10}>
                <Col sm={6}>
                  <SecondaryLabel className="f-12 text-black"> Filter by Status </SecondaryLabel>
                  <TrailerStatusSelector
                    mode="multiple"
                    className="mt-2 w-100"
                    placeholder="Filter by Status"
                    value={filters.filterValue ? filters.filterValue.split(',') : []}
                    onChange={(value) => handleFilterChange(value, 'filterValue')}
                  />
                </Col>
                <Col sm={4}>
                  <TrailerStoreIdSelector
                    label="Filter by Supplier/Store ID"
                    editMode
                    name="Supplier"
                    margin="m-0"
                    placeholder="Filter by Supplier/Store ID"
                    onChange={(value) => handleFilterChange(value, 'storeIdFilterValue')}
                    disabled={userType !== 'CT'}
                    isIDSelector={false}
                  />
                </Col>
                <Col sm={3}>
                  <TrailerScsSelector
                    label="Filter by RSCM"
                    editMode
                    name="RSCM"
                    margin="m-0"
                    customerKey="RSCM"
                    placeholder="Filter by RSCM"
                    onChange={(value) => handleFilterChange(value, 'rscmFilterValue')}
                    disabled={userType !== 'CT'}
                  />
                </Col>
                <Col sm={3}>
                  <TrailerScsSelector
                    label="Filter by SCS"
                    editMode
                    name="SCS"
                    margin="m-0"
                    placeholder="Filter by SCS"
                    customerKey="SCS"
                    onChange={(value) => handleFilterChange(value, 'cscFilterValue')}
                    disabled={userType !== 'CT'}
                  />
                </Col>
                <Col sm={3}>
                  <TrailerScsSelector
                    label="Filter by Assigned to"
                    editMode
                    name="AssignedTo"
                    margin="m-0"
                    customerKey="CT"
                    placeholder="Filter by Assigned To"
                    onChange={(value) => handleFilterChange(value, 'assignedToFilterValue')}
                  />
                </Col>
                <Col sm={5}>
                  <SecondaryLabel className="f-12 text-black"> Filter by Request Creation Date </SecondaryLabel>
                  <RangePicker
                    name="filterByDate"
                    onChange={handleChange}
                    className="mt-2 w-100"
                    placeholder={['Start Date', 'End Date']}
                  />
                </Col>
              </Row>
            )}
            <Row gutter={20} justify="space-between">
              <Col className="my-4">
                <div>
                  <button
                    className="btn btn-dipblue"
                    onClick={() => navigate('/Trailer-Request', { state: { vendorId } })}
                    type="button"
                  >
                    Request Trailer{' '}
                  </button>
                </div>
              </Col>

              <Col className="my-4 mx-1 text-end">
                <button className="btn btn-dipblue" type="button" onClick={handleExport}>
                  Export to Excel
                </button>
              </Col>
            </Row>
            {loading ? (
              <div style={{ marginTop: '15%' }}>
                <ContentSpinner size="large" />
              </div>
            ) : (
              <SaversHomeGrid
                handleNextPage={handleNextPage}
                trailerRequestCt={trailerRequestCt}
                errMessage={errMessage}
                columns={columns}
                loading={loading}
              />
            )}
          </div>
        </Form>
      </div>
    </>
  );
}
